import { createContext } from "react";
import { AlertStatus } from "./AlertProvider";

export type AlertContext = {
  status: AlertStatus;
  alertText: string;
  success: (value?: React.SetStateAction<string>) => void;
  warning: (value?: React.SetStateAction<string>) => void;
  error: (value?: React.SetStateAction<string>) => void;
  clear: (value?: React.SetStateAction<string>) => void;
};

const AlertContext = createContext<AlertContext>(null);
// for debugging
AlertContext.displayName = "AlertContext";

export default AlertContext;
